import { Guideline } from '@/types/community/guideline';

export const guidelines: Guideline[] = [
  {
    id: 'GL001',
    records: [
      {
        content: '1. No bucear en áreas poco profundas\n2. Los niños menores de 12 años deben estar acompañados por adultos\n3. No se permiten contenedores de vidrio\n4. Se requiere traje de baño apropiado\n5. No correr en la cubierta de la piscina',
        category: 'amenity_usage',
        subPolicy: 'swimming_pool',
        attachments: [
          {
            id: 'ATT001',
            name: 'pool_rules.pdf',
            type: 'application/pdf',
            size: 1024,
            path: '/documents/guidelines/GL001/pool_rules.pdf',
            url: 'https://example.com/docs/pool_rules.pdf',
            uploadedAt: new Date('2024-01-01')
          }
        ]
      },
      {
        content: '1. Máximo 2 horas por sesión\n2. Se requiere ropa de gimnasio apropiada\n3. Limpiar el equipo después de usarlo\n4. No se permiten alimentos ni bebidas\n5. Los niños menores de 16 años deben estar supervisados',
        category: 'amenity_usage',
        subPolicy: 'gym',
        attachments: []
      },
      {
        content: '1. Un espacio de estacionamiento por unidad\n2. No estacionar en carriles de bomberos\n3. Estacionamiento de visitantes disponible en áreas designadas\n4. No estacionamiento nocturno para vehículos comerciales\n5. Reportar vehículos abandonados inmediatamente',
        category: 'parking_vehicles',
        subPolicy: 'resident_parking',
        attachments: []
      },
      {
        content: '1. Mantener niveles de ruido razonables\n2. No fiestas después de las 10 PM\n3. Disponer de la basura correctamente\n4. Respetar las áreas comunes\n5. Reportar problemas de mantenimiento prontamente',
        category: 'general_conduct',
        subPolicy: 'noise_levels',
        attachments: []
      },
      {
        content: '1. Todos los visitantes deben estar registrados\n2. Las cámaras de seguridad están monitoreadas\n3. Reportar actividad sospechosa\n4. Mantener puertas y ventanas cerradas\n5. Los contactos de emergencia deben estar actualizados',
        category: 'safety_security',
        subPolicy: 'access_control',
        attachments: []
      },
      {
        content: '1. Enviar solicitudes a través del portal\n2. Las solicitudes de emergencia tienen prioridad\n3. Proporcionar acceso cuando se solicite\n4. Hacer seguimiento al trabajo completado\n5. Calificar la calidad del servicio',
        category: 'maintenance_requests',
        subPolicy: 'request_procedures',
        attachments: []
      },
      {
        content: '1. Las comunicaciones oficiales se envían por correo electrónico y portal\n2. Las notificaciones urgentes se envían por SMS\n3. Aviso mínimo de 24 horas para cambios\n4. Los eventos se anuncian con 7 días de anticipación\n5. Las respuestas deben confirmarse en 48 horas',
        category: 'announcements_notifications',
        subPolicy: 'communication_channels',
        attachments: []
      },
      {
        content: '1. Los gastos comunes se dividen equitativamente entre todas las unidades\n2. Tarifa de mantenimiento mensual: $150.00 por unidad\n3. Fondo de reserva para emergencias: 10% de los ingresos mensuales\n4. El seguro del condominio cubre daños estructurales\n5. Los informes financieros se publican trimestralmente',
        category: 'common_expenses',
        subPolicy: 'utility_sharing',
        attachments: []
      }
    ],
    status: 'active',
    author: {
      id: 'EMP001',
      name: 'Gerente Comunitario',
              type: 'employee'
    },
    effectiveDate: new Date('2024-01-01'),
    version: '1.0',
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  }
]; 